import * as z from "zod";

export const getPayPalConnectionStatus = {
  name: "getPayPalConnectionStatus" as const,
  input: z.object({}),
  output: z.object({ connected: z.boolean() }),
};
